module.exports = __webpack_public_path__ + "img/13.4eccac91.png";